"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselButton: function() {
        return _index.CarouselButton;
    },
    carouselButtonClassNames: function() {
        return _index.carouselButtonClassNames;
    },
    renderCarouselButton_unstable: function() {
        return _index.renderCarouselButton_unstable;
    },
    useCarouselButtonStyles_unstable: function() {
        return _index.useCarouselButtonStyles_unstable;
    },
    useCarouselButton_unstable: function() {
        return _index.useCarouselButton_unstable;
    }
});
const _index = require("./components/CarouselButton/index");
